// extracted by mini-css-extract-plugin
module.exports = {"cardStyle":"JamesHardie_cardStyle__2a3Ex"};